import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import { type ProductsPopProps } from '../ProductsPop';

export enum ProductTreatments {
  BREAKOUTS = 'Breakouts',
  CLOGGED_PORES = 'Clogged pores',
  WHITEHEADS = 'Whiteheads',
  REDNESS = 'Redness',
  BLACKHEADS = 'Blackheads',
  SKIN_TEXTURE = 'Skin texture',
  FINE_LINES = 'Fine lines',
  WRINKLES = 'Wrinkles',
  DARK_SPOTS = 'Dark spots',
  DULLNESS = 'Dullness',
}

export const POP_REDESIGN_PRODUCTS_CONTENT: ProductsPopProps = {
  title: 'Rx formulas',
  subtitle:
    'Personalized by a licensed dermatology provider using only clinically proven ingredients. Your custom formula is delivered to your door every 2 months.*',
  ctaButton: {
    buttonText: 'Get my formula',
  },
  disclaimerText: '*Subject to consultation. Cancel anytime.',
  products: [
    {
      image: (
        <StaticImage
          src="../images/acne@2x.jpg"
          alt="Curology Custom Formula Rx for Acne, white bottle on beige background."
          width={335}
        />
      ),
      name: (
        <React.Fragment>
          Custom Formula <sup>Rx</sup> for acne
        </React.Fragment>
      ),
      price: (
        <React.Fragment>
          <strong>$29.95</strong>/month
        </React.Fragment>
      ),
      body: 'Ingredients proven to tackle',
      treatments: [
        ProductTreatments.BREAKOUTS,
        ProductTreatments.CLOGGED_PORES,
        ProductTreatments.WHITEHEADS,
        ProductTreatments.BLACKHEADS,
      ],
      url: '/products/custom-formula-acne/',
    },
    {
      image: (
        <StaticImage
          src="../images/antiAging@2x.jpg"
          alt="Curology Future-Proof Rx for anti-aging, purple bottle on beige background."
          width={335}
        />
      ),
      name: (
        <React.Fragment>
          Future-Proof <sup>Rx</sup> for anti-aging
        </React.Fragment>
      ),
      price: (
        <React.Fragment>
          <strong>$29.95</strong>/month
        </React.Fragment>
      ),
      body: 'Ingredients proven to tackle',
      treatments: [
        ProductTreatments.SKIN_TEXTURE,
        ProductTreatments.FINE_LINES,
        ProductTreatments.WRINKLES,
        ProductTreatments.DARK_SPOTS,
        ProductTreatments.DULLNESS,
      ],
      url: '/products/future-proof-anti-aging/',
    },
  ],
};
